import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';
import { ReducerActionRotaSP } from 'store/modules/types';
import { ConsultarUsuarioRequest, Types } from './types';
import { consultarUsuarioSuccess, consultarUsuarioFailure } from './actions';

function* consultarUsuarioRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarUsuarioRequest } = request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`usuarios/${payload.id}`,
	);
	if (response.status === 200 || response.status === 201) {
		yield put(consultarUsuarioSuccess(response));
	} else if (response.error) {
		yield put(consultarUsuarioFailure(response.message));
	}
}

export default all([
	takeLatest(Types.CONSULTAR_USUARIO_REQUEST, consultarUsuarioRequest),
]);
